import { render, staticRenderFns } from "./AddCoaches.vue?vue&type=template&id=3d6ad8ee&scoped=true&"
import script from "./AddCoaches.vue?vue&type=script&lang=js&"
export * from "./AddCoaches.vue?vue&type=script&lang=js&"
import style0 from "./AddCoaches.vue?vue&type=style&index=0&id=3d6ad8ee&scoped=true&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6ad8ee",
  null
  
)

export default component.exports